module.exports = __webpack_public_path__ + "static/media/cancel-confirmation.d26e2120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cancel-confirmation.svg
// module id = ./src/assets/images/cancel-confirmation.svg
// module chunks = 6